import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import selectRoleChecker from "@/router/selectRoleChecker";
import auditLogType from "@/types/responses/auditLog";
import i18n from "@/lang/i18n";
import {
  MANAGEMENT_OFFICE_TYPE,
  SUB_MANAGEMENT_OFFICE_TYPE,
} from "@/services/consts";


export default /*@__PURE__*/_defineComponent({
  __name: 'OpenNewWindowIcon',
  props: {
    auditLog: {}
  },
  setup(__props: any) {

const props = __props

function openInNewWindow() {
  const selectedRole = selectRoleChecker.getCurrentRole()
  if (!selectedRole) {
    return
  }

  switch (props.auditLog.auditable_type) {
    case 'account':
      window.open(`/accounts/form/${props.auditLog.auditable_id}`, '_blank')
      break
    case 'operation_office':
      if (selectedRole.organization_type === MANAGEMENT_OFFICE_TYPE || selectedRole.organization_type === SUB_MANAGEMENT_OFFICE_TYPE) {
        window.open(`/operation-offices/form/${props.auditLog.auditable_id}`, '_blank')
      }
      window.open(`/operation-office-edit`, '_blank')
      break
    case 'delivery_plan_work':
      window.open(`/daily-report?delivery_plan_id=${props.auditLog.auditable_id}`, '_blank')
      break
    case 'workload':
      window.open(`/daily-report?delivery_plan_id=${props.auditLog.auditable.delivery_plan_id}`, '_blank')
      break
    case 'vehicle':
      window.open(`/vehicles/form/${props.auditLog.auditable_id}`, '_blank')
      break
    case 'spot':
      window.open(`/spots?id=${props.auditLog.auditable_id}`, '_blank')
      break
    case 'report_layout':
      window.open(`/daily-report-layouts?id=${props.auditLog.auditable_id}`, '_blank')
      break
    default:
      break
  }
}

function tooltipText() {
  switch (props.auditLog.auditable_type) {
    case 'account':
      return i18n.global.t('pages.auditLog.openNewWindow.account')
    case 'operation_office':
      return i18n.global.t('pages.auditLog.openNewWindow.operationOffice')
    case 'delivery_plan_work':
    case 'workload':
      return i18n.global.t('pages.auditLog.openNewWindow.dailyReports')
    case 'vehicle':
      return i18n.global.t('pages.auditLog.openNewWindow.vehicle')
    case 'spot':
      return i18n.global.t('pages.auditLog.openNewWindow.spots')
    case 'report_layout':
      return i18n.global.t('pages.auditLog.openNewWindow.reportLayouts')
    default:
      return ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createBlock(_component_v_tooltip, {
    location: "bottom",
    "open-delay": 500
  }, {
    activator: _withCtx(({ props: activatorProps }) => [
      _createElementVNode("span", _normalizeProps(_guardReactiveProps(activatorProps)), [
        _createVNode(_component_v_btn, {
          density: "default",
          variant: "text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openInNewWindow()))
        }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("span", { class: "material-symbols-outlined" }, " open_in_new ", -1)
          ]))]),
          _: 1
        })
      ], 16)
    ]),
    default: _withCtx(() => [
      _createTextVNode(" " + _toDisplayString(tooltipText()), 1)
    ]),
    _: 1
  }))
}
}

})